import { getEnvironment, LOCAL } from '@atlassian/temp-shared';
import { PPCFeatureFlagKeys, STATSIG_FEATURE_GATES, STATSIG_FEATURE_GATES_LOCAL_VALUE } from '@css-xp/ppc-constants';
import { useGate } from '@css-xp/ppc-feature-gate-context/src/hooks/use-gate';
import { GetUserProfile } from '../../security';
/* Accessing FF to have feature launch enable disable
 *usage of this
 * const [isEnabled] = useFeatureToggle();
 *   { isEnabled(ENABLE_CREDIT_NOTES) &&
 *   (<ReactComponent/>)
 *   }
 */

const statsigFeatureGates = new Set(Object.values(STATSIG_FEATURE_GATES));
type FeatureFlagKey = keyof typeof PPCFeatureFlagKeys;
type StatsigFeatureFlagKey = keyof typeof STATSIG_FEATURE_GATES;
type FeatureFlagValue = typeof PPCFeatureFlagKeys[FeatureFlagKey] | typeof STATSIG_FEATURE_GATES[StatsigFeatureFlagKey];

export const useFeatureToggle = () => {
  const userProfile = GetUserProfile();
  const isStatsigFeatureEnabled = useGate();

  const isEnabled: any = (flag: FeatureFlagValue, defaultValue = false) => {
    if (statsigFeatureGates.has(flag as any)) {
      if (getEnvironment() === LOCAL) {
        return STATSIG_FEATURE_GATES_LOCAL_VALUE[flag] ?? defaultValue;
      }
      return isStatsigFeatureEnabled(flag, defaultValue);
    } else {
      // @ts-ignore
      return userProfile?.featureFlags?.[flag] ?? defaultValue;
    }
  };

  return [isEnabled];
};
